const calculateBusinessDays = (days, getIsIsrael) => {
  const isIsrael = getIsIsrael();

  let date = new Date();
  let businessDaysAdded = 0;

  while (businessDaysAdded < days) {
    date.setDate(date.getDate() + 1);
    const dayOfWeek = date.getDay(); // 0 is Sunday, 6 is Saturday

    if (isIsrael) {
      // Israel: Sunday (0) to Thursday (4) are business days
      if (dayOfWeek >= 0 && dayOfWeek <= 4) {
        businessDaysAdded++;
      }
    } else {
      // Default: Monday (1) to Friday (5) are business days
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        businessDaysAdded++;
      }
    }
  }

  return date;
};

export default calculateBusinessDays;
